<script lang="ts" module>
	export interface InputErrorProps {
		dataCy: string;
		children?: import('svelte').Snippet;
		class?: string | undefined;
	}
</script>

<script lang="ts">
	import { twMerge } from 'tailwind-merge';
	import { Txt } from '../../Txt';

	let { ...props }: InputErrorProps = $props();
</script>

<Txt variant="label4" {...props} class={twMerge('mt-1 text-red-500', props.class)}>
	{@render props.children?.()}
</Txt>
